import React from 'react'
import { connect } from 'react-redux'
import { change as changeFieldValue } from 'redux-form';
import selecionarPrestador from '../../actions/prestador/selecionarPrestador';


export class Prestador extends React.Component {
  selecionarPrestador (prestador) {
    this.props.changeFieldValue('formularioCadastrarPrestador',
      'logradouro', prestador.logradouro);
    this.props.changeFieldValue('formularioCadastrarPrestador',
      'complemento', prestador.complemento);
    this.props.changeFieldValue('formularioCadastrarPrestador',
      'bairro', prestador.bairro);
    this.props.changeFieldValue('formularioCadastrarPrestador',
      'localidade', prestador.localidade);
    this.props.changeFieldValue('formularioCadastrarPrestador',
      'uf', prestador.uf);
    this.props.changeFieldValue('formularioCadastrarPrestador',
      'cep', prestador.cep);
    this.props.changeFieldValue('formularioCadastrarPrestador',
      'idPrestador', prestador.id);
    this.props.changeFieldValue('formularioCadastrarPrestador',
      'nome', prestador.nome);
    this.props.changeFieldValue('formularioCadastrarPrestador',
        'responsavel', prestador.responsavel);
    this.props.changeFieldValue('formularioCadastrarPrestador',
      'numero', prestador.numero);
    this.props.changeFieldValue('formularioCadastrarPrestador',
        'telefone', prestador.telefone);
    this.props.changeFieldValue('formularioCadastrarPrestador',
        'cpfCnpj', prestador.cpfCnpj);
  }




  render () {
    return (
      <div className="geral">
        <div className="resumo">
          <div className="row">
            <div className="col">
              <span className="titulo-mobile">Número:&nbsp;</span>{this.props.prestador.id}
            </div>
            <div className="col">
              <span className="titulo-mobile">Nome:&nbsp;</span>{this.props.prestador.nome}
            </div>
            <div className="col">
              <span className="titulo-mobile">Responsável:&nbsp;</span>{this.props.prestador.responsavel}
            </div>
            <div className="col">
              <span className="titulo-mobile">CPF/CNPJ:&nbsp;</span>{this.props.prestador.cpfCnpj}
            </div>
            <div className="col">
              <span className="titulo-mobile">Telefone:&nbsp;</span>{this.props.prestador.telefone}
            </div>
            <div className="col">
              <span className="titulo-mobile">Localidade:&nbsp;</span>{this.props.prestador.localidade+' - '+ this.props.prestador.uf}
            </div>


            <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">
              <div className="acoes">
                <div className="botoes">
                  <button type="button" className="btn btn-excluir"
                          data-toggle="modal"
                          data-target="#modalConfirmacaoExclusaoPrestador"
                          onClick={() => this.props.selecionarPrestador(this.props.prestador)}>
                    <i className="material-icons nav-icon">&#xe872;</i>
                  </button>
                  <button type="button" className="btn btn-editar ml-2"
                          data-toggle="modal"
                          data-target="#modalCadastrarPrestador"
                          onClick={() => {
                            this.props.selecionarPrestador(this.props.prestador)
                            this.selecionarPrestador(this.props.prestador)
                          }}>
                    <i className="material-icons nav-icon">&#xe150;</i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export function mapStateToProps () {
  return {}
}

export default connect(mapStateToProps, {
  selecionarPrestador,
  changeFieldValue
})(Prestador)
